import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useState } from 'react';
import './Filters.pcss';
import { GenreFilter } from '../GenreFilter';
import { ReleaseFilter } from '../ReleaseFilter';
import { ReleaseType } from '../types';
import { SearchFilter } from '../SearchFilter';
import { PlatformFilter } from '../PlatformFilter';
import { parseJSONString } from '../../../../../utils/parse-json-string';
import { useStoreContext } from '../../hooks/useStoreContext';
export const Filters = ({ element, state }) => {
    const { setFilteredItems } = useStoreContext();
    const [searchValue, setSearchValue] = useState('');
    const [genreSearch, setGenreSearch] = useState('');
    const [release, setRelease] = useState(ReleaseType.All);
    const [platform, setPlatform] = useState('');
    const onSearchByName = (e) => {
        setSearchValue(e.target.value);
    };
    const onSelectGenre = (value) => {
        setGenreSearch(value);
    };
    const onSelectRelease = (value) => {
        setRelease(value);
    };
    const onSelectPlatform = (value) => {
        setPlatform(value);
    };
    useLayoutEffect(() => {
        const GameCards = Array.from(element.querySelectorAll('.new-store-card'));
        const filteredItems = GameCards.filter((card) => {
            const gameName = card.getAttribute('data-game-name')?.toLowerCase();
            const nameMatch = gameName?.includes(searchValue?.toLowerCase());
            const genres = parseJSONString(card.getAttribute('data-genre') ?? '[]');
            const genreMatch = genres.some((genre) => genre.includes(genreSearch));
            const releases = parseJSONString(card.getAttribute('data-release') ?? '[]');
            const releaseMatch = releases.some((currentRelease) => release === '' ? true : currentRelease.toLowerCase() === release?.toLowerCase());
            const platforms = parseJSONString(card.getAttribute('data-platform') ?? '[]');
            const platformMatch = platforms.some((currentPlatform) => platform === '' || currentPlatform.toLowerCase() === platform?.toLowerCase());
            if (!nameMatch || !genreMatch || !releaseMatch || !platformMatch) {
                return false;
            }
            return true;
        });
        const hiddenItems = GameCards.filter((card) => !filteredItems.includes(card));
        setFilteredItems({
            hide: hiddenItems,
            show: filteredItems,
        });
    }, [searchValue, genreSearch, release, platform]);
    return (_jsxs("div", { className: "new-store__filters", children: [_jsx(SearchFilter, { onSearchByName: onSearchByName, searchName: searchValue }), _jsx(GenreFilter, { element: element, handleGenreChange: onSelectGenre, selectedGenre: genreSearch, state: state }), _jsx(ReleaseFilter, { selectedReleaseType: release, onReleaseTypeChange: onSelectRelease, state: state, element: element }), _jsx(PlatformFilter, { selectedPlatformType: platform, onSelectPlatform: onSelectPlatform, state: state, element: element })] }));
};
